export const DELETE_DASHBOARD_ITEM_NAME = "delete_dashboard_item";
export const DELETE_DASHBOARD_ITEM_DESC = `Deletes a single dashboard item via the DeleteDashboardItem GraphQL mutation.

Use when the user requests removing a specific card or widget from an existing dashboard. This is a destructive write operation and must go through confirmation.

Input:
- 'dashboardId' (required): Dashboard ID (GraphQL global ID) that owns the item. Used for cache revalidation.
- 'dashboardItemId' (required): Dashboard item ID (GraphQL global ID) to delete.

Output:
- Returns only the deleted dashboard item ID.

Notes:
- Revalidates the parent dashboard cache tag after deletion.
- If either ID is invalid or the item no longer exists, surface the error so the user can retry or refresh.`;
